<template>
  <div class="d-flex">
    <slot />
    <icon-button
      v-show="showIcon"
      @click="onIconButtonClick"
      :icon="icon"
      class="align-self-center"
    />
  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';
import IconButton from '@/components/button/IconButton.vue';

@Component({
  components: { IconButton },
})
export default class CombinedInputWithIconButton extends Vue {
  @Prop({ default: true }) readonly showIcon!: boolean;
  @Prop({ default: 'mdi-close' }) readonly icon!: string;

  onIconButtonClick() {
    this.$emit('click-icon');
  }
}
</script>
